export default __webpack_public_path__ + "static/media/detail.095f2b0a.svg";